(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chamado', {
                parent: 'entity',
                url: '/chamado?page&sort&search&situacao&clienteId&tipoChamado&moduloId',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Chamados'
                },
                ncyBreadcrumb: {
                    label: 'Chamados'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamados.html',
                        controller: 'ChamadoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    situacao: null,
                    tipoChamado: null,
                    clienteId: null,
                    moduloId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            situacao: $stateParams.situacao,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            tipoChamado: $stateParams.tipoChamado,
                            moduloId: $stateParams.moduloId,
                            clienteId: $stateParams.clienteId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('new-chamado', {
                parent: 'chamado',
                url: '/chamado-new',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Inclusão de Chamado'
                },
                ncyBreadcrumb: {
                    label: 'Inclusão de Chamado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-edit.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['Chamado', function (Chamado) {
                        return Chamado.criar().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('new-suporte', {
                parent: 'chamado',
                url: '/chamado-suporte',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Registro de Atividade'
                },
                ncyBreadcrumb: {
                    label: 'Registro de Atividade'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-suporte.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['Chamado', function (Chamado) {
                        return Chamado.criar().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('edit-chamado', {
                parent: 'chamado',
                url: '/chamado-edit/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Edição de Chamado'
                },
                ncyBreadcrumb: {
                    label: 'Edição de Chamado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-edit.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('solicitar-desenvolvimento', {
                parent: 'edit-chamado',
                url: '/criar-tarefa/{situacaoId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Solci'
                },
                ncyBreadcrumb: {
                    label: 'Solicitação de desenvolvimento'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/solicitar-tarefa.html',
                        controller: 'ChamadoDesenvolvimentoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    chamado: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    situacaoId: ['$stateParams', function ($stateParams) {
                        return $stateParams.situacaoId;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('aprovar-desenvolvimento', {
                parent: 'edit-chamado',
                url: '/aprovar-tarefa/{situacaoId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Solcitação de Desenvolvimento'
                },
                ncyBreadcrumb: {
                    label: 'Aprovação de Desenvolvimento'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/aprovar-tarefa.html',
                        controller: 'AprovarDesenvolvimentoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    chamado: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    situacaoId: ['$stateParams', function ($stateParams) {
                        return $stateParams.situacaoId;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('delete-chamado', {
                parent: 'chamado',
                url: '/chamado-delete/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/chamado/chamado-delete-dialog.html',
                        controller: 'ChamadoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Chamado', function (Chamado) {
                                return Chamado.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('home', null, {reload: 'home'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
